import { render, staticRenderFns } from "./DesktopSideBar.vue?vue&type=template&id=a4ee9bce&scoped=true&"
import script from "./DesktopSideBar.vue?vue&type=script&lang=js&"
export * from "./DesktopSideBar.vue?vue&type=script&lang=js&"
import style0 from "./DesktopSideBar.vue?vue&type=style&index=0&id=a4ee9bce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ee9bce",
  null
  
)

export default component.exports